export * as PrimProductDetail from "./product-detail";
